import React from "react"
import { ProfileContext } from "../ProfileProvider"
import { TenantProfile } from "@hydrologiq/gql-experience/graphql"

export function useGetProfile(): TenantProfile {
  const context = React.useContext(ProfileContext)
  if (context === undefined) {
    throw new Error("useGetProfile must be used within a ProfileProvider")
  }
  return context.profile
}
